import Admin from "./Admin";
import Organization from "./Organization";
import XO from "./XO";
import Shared from "./Shared";

const routes = [...Admin, ...Organization, ...XO, ...Shared];

export default routes;
